<template>
  <div class="wrapper col-8">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">

        <!-- HEADER -->
        <div slot="header">
          <i class="fa fa-bell-o"></i> Land Movement
          <div class="card-header-actions">
                <b-button v-if="submittedId === 0" type="button" size="sm" variant="primary" @click="mofaEventHandler">
                  <i class="fa fa-edit"></i> MoFA - EHOC
                </b-button>

                <b-button v-else-if="submittedId === 1" type="button" size="sm" variant="primary" @click="mofaCentcomEventHandler">
                  <i class="fa fa-edit"></i> CENTCOM Form
                </b-button>

                <b-button v-else-if="submittedId === 2" type="button" size="sm" variant="primary" @click="mofaEventHandler">
                  <i class="fa fa-edit"></i> MoFA - EHOC
                </b-button>

                <b-button v-if="submittedId === 2" type="button" size="sm" variant="primary" @click="mofaCentcomEventHandler">
                  <i class="fa fa-edit"></i> CENTCOM Form
                </b-button>
          </div>
        </div>
        <!--// HEADER -->

        <!-- FORM -->
        <b-form id="landMission">
          <b-container>
              <b-row>
                <b-col class="col-12"><h5>1. Purpose of the mission<span class="required">*</span></h5></b-col><br>
              </b-row>
              <b-row>                
                <b-col class="col-4">
                  <b-form-group class="required" :class="{error: validation.hasError('purposeId')}">
                    <b-form-select 
                       v-if="purposeList"
                       type="text" placeholder="Mission Purpose" 
                       text-field="description" 
                       value-field="id"
                       :options="purposeList"
                       :value="purposeId"
                       @change="purposeChangeEventHandler">
                       <template slot="first">
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                    </b-form-select>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('purposeId') }}</small>
                  </b-form-group>
                </b-col>
                <b-col class="col-4" v-if="isOtherPurpose">
                  <b-form-group class="required" :class="{error: validation.hasError('purposeOthers')}">
                      <b-form-input ref="purposeOthers" v-model="purposeOthers" placeholder="Enter other purpose" @keyup.native="changeEventHandler"></b-form-input></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('purposeOthers') }}</small>
                  </b-form-group>  
                </b-col>
              </b-row>

              <hr>

              <b-row>
                 <b-col class="col-12">
                    <h5>2. Route Map<span class="required">*</span></h5>
                 </b-col>
              </b-row> 
              <b-row>
                <b-col>
                  <small class="text-danger font-weight-bold mb-10">{{ validation.firstError('staticMap.roadmap') }}</small>
                </b-col>
              </b-row>             
              <b-row>                                
                  <b-col>                  
                      <div class="align-middle emptyImage">
                          <b-form-group>
                              <b-img v-if="staticMap" fluid :src="staticMap.roadmap"/> 
                          </b-form-group>
                      </div>                      
                  </b-col>
                  <!-- <b-col class="col-md-6 col-sm-6 col-xs-12">
                    <div class="align-middle emptyImage">
                        <b-img v-if="staticMap" fluid :src="staticMap.satellite"/>
                    </div>
                  </b-col>                   -->
               </b-row>
              <br>
              <b-row>   
                <b-col class="col-12">
                  <b-button size="sm" variant="secondary" @click="createRoute"><i class="fa fa-map-o"></i> Create Route</b-button>                  
                </b-col>
              </b-row>          
              
              <hr>

              <b-row>
                <b-col class="col-12"><h5>2.1  Waypoints and Static Locations duration the Mission </h5></b-col><br>
                <b-col class="col-6">                
                 <b-table hover="hover" striped="striped" bordered="bordered" fixed="fixed" responsive="sm" :items="waypoints" :fields="waypoint_fields" :current-page="currentPage" :per-page="perPage">
                </b-table>
                <nav v-if="waypoints.length > 5">
                  <b-pagination :total-rows="getRowCount(waypoints)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>                  
                </nav>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col class="col-12">
                    <h5>3.  Convoy Movements<span class="required">*</span></h5>
                </b-col>
              </b-row>
              <b-row>
                 <b-col class="col-12">
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoys') }}</small>
                 </b-col>
              </b-row>
              <b-row>
                <b-col class="col-xs-12 col-sm-12 col-md-12">                  
                  <table class="table table-bordered table-hover table-md table-sm table-xs mb-2" :class="{error: validation.hasError('convoys')}">
                    <thead class="col-12">
                      <th scope="colgroup" class="center"></th>
                      <th colspan="3" scope="colgroup" class="center" style="text-align:center">Departure<br></th>
                      <th colspan="3" scope="colgroup" class="center" style="text-align:center">Arrival</th>
                      <!-- <th colspan="2" scope="colgroup" class="center" style="text-align:center">Estimate Travel</th> -->
                    </thead>
                    <thead>
                      <th class="no-border-right">
                          <div class="float-left"><!--v-model="selectAll" -->
                            <!-- <input type="checkbox" class="select-row" @click="select('convoys', $event)" value="all" title="Select All"> &nbsp; -->
                            <!-- v-if="convoys_checked_all"  -->
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <b-button type="button" class="btn btn-secondary btn-sm" @click="deleteAllModalItems('convoys')" title="Delete" :disabled="convoys_checked.length === 0"><i class="fa fa-trash-o"></i></b-button>
                          </div>
                      </th>
                      <th scope="col">Departure Location</th>
                      <th scope="col">Departure Date</th>
                      <th scope="col">GPS Coordinates</th>
                      <th scope="col">Arrival Location</th>
                      <th scope="col">Arrival Date</th>
                      <th scope="col">GPS Coordinates</th>
                      <!-- <th scope="col">Distance</th>
                      <th scope="col">Duration</th> -->
                    </thead>
                    <tbody>
                      <tr v-if="convoys" v-for="(d, index) in convoys" :key="index">
                        <td width="70px">
                          <div class="float-left"><!--v-model="selected"-->
                            <input type="checkbox" v-model="d.checked" class="select-row" :value="index" @click="select('convoys', $event)">&nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="updateModal(index, 'convoy')" v-b-modal.convoy><i class="fa fa-pencil"></i></button>
                            <!-- <b-button v-if="convoys_checked[index] || convoys_checked_all" type="button" class="btn btn-secondary btn-sm" @click="deleteHandler('convoy', index)"><i class="fa fa-trash-o"></i> Delete</b-button> -->
                          </div>
                        </td>
                        <td> {{ d.departure_location }} </td>
                        <td> {{ d.departure_date | formatDate('DD/MM/YYYY HH:mm') }} </td>
                        <td> {{ d.departure_gps }} </td>
                        <td> {{ d.arrival_location }} </td>
                        <td> {{ d.arrival_date | formatDate('DD/MM/YYYY HH:mm') }} </td>
                        <td> {{ d.arrival_gps }} </td>
                       <!--  <td> {{ d.total_distance }} </td>
                        <td> {{ d.total_duration }} </td> -->
                      </tr>
                    </tbody>
                  </table>                  
                  <b-row>
                    <b-col>
                      <b-button size="sm" id="convoy" variant="secondary" v-b-modal.convoy @click="resetValidation">
                        <i class="fa fa-plus"></i> Add Convoy
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                  <b-col class="col-12">
                    <h5>4. Mission Participants</h5></b-col> <!-- <span class="required">*</span> -->
                  </b-col>
              </b-row>

              <b-row>
                 <b-col class="col-12">
                    <small class="text-danger font-weight-bold">{{ validation.firstError('participants') }}</small>
                 </b-col>
              </b-row>

              <b-row>                
                <b-col class="col-md-12 col-sm-12 col-xs-12">
                  <table class="table table-bordered table-hover table-md table-sm table-xs mb-2">
                    <thead>
                       <th class="no-border-right">
                          <div class="float-left" v-if="participants">
                            
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <b-button type="button" class="btn btn-secondary btn-sm" @click="deleteAllModalItems('participants')" title="Delete" :disabled="participants_checked.length === 0"><i class="fa fa-trash-o"></i></b-button>
                            <!-- <input type="checkbox" class="select-row" @click="select('participants')" title="Select All" v-model="participants_checked_all"> &nbsp; -->
                            
                          </div>
                      </th>
                      <th scope="col">No.</th>
                      <th scope="col">Name</th>
                      <th scope="col">Agency</th>
                      <th scope="col">Convoy Leader Mobile No./Sat Phone</th>
                    </thead>
                     <tbody>
                      <tr v-if="participants.length === 0">
                        <td>
                          <div class="float-left">
                          </div>
                        </td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                      </tr>
                      <tr v-if="participants" v-for="(d, index) in participants" :key="index">
                        <td width="70px">
                          <div class="float-left">
                            <!-- <input type="checkbox" class="select-row" v-model="participants_checked[key]"> &nbsp; -->
                            <input type="checkbox" v-model="d.checked" class="select-row" :value="index" @click="select('participants', $event)">&nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="updateModal(index, 'participant')" v-b-modal.participant><i class="fa fa-pencil"></i></button>
                            <!-- <b-button v-if="participants_checked_all || participants_checked[key]" type="button" class="btn btn-secondary btn-sm"  @click="deleteHandler('participant', key)"><i class="fa fa-trash-o"></i> Delete</b-button> -->
                          </div>
                        </td>
                        <td> {{ index + 1  }}</td>
                        <td> {{ d.name }} </td>
                        <td> {{ getAgencyName(d) }}</td>
                        <td> {{ d.mobile_no }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <b-row>
                    <b-col>
                      <b-button size="sm" variant="secondary" v-b-modal.participant @click="resetValidation">
                        <i class="fa fa-plus"></i> Add Participant
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col class="col-12"><h5>5. Vehicles Details</h5></b-col> <!-- <span class="required">*</span> -->
              </b-row>
              <!-- <b-row>
                 <b-col class="col-12">
                    <small class="text-danger font-weight-bold">{{ validation.firstError('vehicles') }}</small>
                 </b-col>
              </b-row> -->

              <b-row>
                <b-col>
                  <table class="table table-bordered table-hover table-md table-sm table-xs mb-2">
                    <thead>
                      <th>
                          <div class="float-left">
                            <!-- <input type="checkbox" class="select-row" @click="select('vehicles')" title="Select All" v-model="vehicles_checked_all"> &nbsp; -->
                            <!-- <b-button v-if="vehicles_checked_all" @click="deleteAllModalItems('vehicles')" type="button" class="btn btn-secondary btn-sm" title="Delete"><i class="fa fa-trash-o"></i></b-button> -->
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <b-button type="button" class="btn btn-secondary btn-sm" @click="deleteAllModalItems('vehicles')" title="Delete" :disabled="vehicles_checked.length === 0"><i class="fa fa-trash-o"></i></b-button>
                          </div>
                      </th>
                      <th scope="col">Make & Model</th>
                      <th scope="col">Color</th>
                      <th scope="col">Plate</th>
                      <th scope="col">Roof Marking</th>
                      <th scope="col">Armored</th>
                    </thead>
                    <tr v-if="vehicles.length === 0">
                      <td>
                        <div class="float-left"></div>
                      </td>
                      <td scope="col">&nbsp;</td>
                      <td scope="col">&nbsp;</td>
                      <td scope="col">&nbsp;</td>
                      <td scope="col">&nbsp;</td>
                      <td scope="col">&nbsp;</td>
                    </tr>
                     <tr v-if="vehicles" v-for="(d, index) in vehicles" :key="index">
                        <td width="70px">
                          <div class="float-left">
                            <!-- <input type="checkbox" class="select-row" v-model="vehicles_checked[index]"> &nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="updateModal(index, 'vehicle')" v-b-modal.vehicle><i class="fa fa-pencil"></i></button> -->

                            <input type="checkbox" v-model="d.checked" class="select-row" :value="index" @click="select('vehicles', $event)">&nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="updateModal(index, 'vehicle')" v-b-modal.vehicle><i class="fa fa-pencil"></i></button>
                            
                            <!-- <b-button v-if="vehicles_checked[index]" type="button" class="btn btn-secondary btn-sm" @click="deleteHandler('vehicle',index)"><i class="fa fa-trash-o"></i> Delete</b-button> -->
                          </div>
                        </td>
                        <td> {{ d.model }} </td>
                        <td> {{ d.color }}</td>
                        <td> {{ d.plate }}</td>
                        <td> {{ d.roof_marking }}</td>
                        <td> {{ d.armored | formatBoolean }}</td>
                       </tr>
                  </table>
          
                  <!-- <b-row class="mb-2">
                    <b-col>
                      <i class="fa fa-lightbulb-o text-warning fa-1x"></i> 
                      <small class="text-muted">The number of participants should be equal to the number of vehicles.</small>
                    </b-col>
                  </b-row> -->

                  <b-row>
                    <b-col>
                      <b-button size="sm" variant="secondary" v-b-modal.vehicle @click="resetValidation">
                        <i class="fa fa-plus"></i> Add Vehicle
                      </b-button>                      
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col class="col-12"><h5>6. Trucks Details</h5></b-col>
              </b-row>
              <!-- <b-row>
                 <b-col class="col-12">
                    <small class="text-danger font-weight-bold">{{ validation.firstError('trucks') }}</small>
                 </b-col>
              </b-row>   -->
              <b-row>
                <b-col>
                  <table class="table table-bordered table-hover table-md table-sm table-xs mb-2">
                    <thead>
                       <th>
                          <div class="float-left">
                            <!-- <input type="checkbox" class="select-row" @click="select('trucks')" title="Select All"  v-model="trucks_checked_all"> &nbsp;
                            <b-button v-if="trucks_checked_all" type="button" class="btn btn-secondary btn-sm" @click="deleteAllModalItems('trucks')" title="Delete"><i class="fa fa-trash-o"></i></b-button> -->
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <b-button type="button" class="btn btn-secondary btn-sm" @click="deleteAllModalItems('trucks')" title="Delete" :disabled="trucks_checked.length === 0"><i class="fa fa-trash-o"></i></b-button>
                          </div>
                        </th>
                      <th scope="col">Name of Driver</th>
                      <th scope="col">Model</th>
                      <th scope="col">Color</th>
                      <th scope="col">Truck Plate Number</th>
                      <th scope="col">Roof Marking</th>
                      <th scope="col">Type of Load</th>
                      <th scope="col">Weight</th>
                    </thead>
                     <tr v-if="trucks.length === 0">
                        <td><div class="float-left"></div></td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                        <td scope="col">&nbsp;</td>
                       </tr>
                      <tr v-if="trucks" v-for="(d, index) in trucks" :key="index">
                         <td width="70px">
                          <div class="float-left">
                            <input type="checkbox" v-model="d.checked" class="select-row" :value="index" @click="select('trucks', $event)">&nbsp;
                            <button type="button" class="btn btn-secondary btn-sm" @click="updateModal(index, 'truck')" v-b-modal.truck><i class="fa fa-pencil"></i></button>

                            <!-- <input type="checkbox" class="select-row" data-id="" v-model="trucks_checked"> &nbsp;
                            <button type="button" class="btn btn-secondary btn-sm"  @click="updateModal(index, 'truck')" v-b-modal.truck><i class="fa fa-pencil"></i></button> -->
                            <!-- <b-button v-if="trucks_checked_all || trucks_checked" type="button" class="btn btn-secondary btn-sm" @click="deleteHandler('truck',index)"><i class="fa fa-trash-o"></i> Delete</b-button> -->
                          </div>
                        </td>
                        <td> {{ d.driver_name }} </td>
                        <td> {{ d.model }}</td>
                        <td> {{ d.color }}</td>
                        <td> {{ d.plate_no }}</td>
                        <td> {{ d.roof_marking }}</td>
                        <td> {{ d.load_type }}</td>
                        <td> {{ d.weight }}</td>
                      </tr>
                  </table>
                  <b-row>
                    <b-col>
                      <b-button size="sm" variant="secondary" v-b-modal.truck @click="resetValidation">
                        <i class="fa fa-plus"></i> Add Truck
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col class="col-12"><h5>7.  Photos<span class="required">*</span></h5></b-col>
              </b-row>
              <b-row>
                <b-col class="col-12">
                  <small class="text-danger font-weight-bold">{{ validation.firstError('photos') }}</small>
                </b-col>
              </b-row>
              <b-row>  
                <b-col>
                  <div class="thumbnail emptyImage">

                    <div class="card-columns">
                        <div class="card" v-for="(photo, index) in photos" :key="photo.id" v-if="photos">
                            <img class="card-img-top img-fluid" :src="photo.image" :alt="photo.description">
                            <p class="card-text">
                                {{photo.description}}
                                <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                                  <template slot="button-content">
                                    <i class="icon-settings"></i>
                                  </template>
                                  <b-dropdown-item @click="selectedPhotoEventHandler(photo)" v-b-modal.confirmDeletePhotoModal v-b-modal.modal-center> Delete</b-dropdown-item>
                                  <b-dropdown-item @click="downloadEventHandler(photo)"> Download</b-dropdown-item>
                                </b-dropdown>
                            </p>
                        </div>                          
                    </div>

                    <!-- <b-card-group deck>                    
                        <b-card v-for="(photo, index) in photos" :key="photo.id" v-if="photos"
                              :img-src="photo.image"
                              img-alt="Image"
                              img-top
                              tag="article"
                              style="max-width: 15rem;">
                              <p class="card-text">
                                  {{photo.description}}
                              <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                                <template slot="button-content">
                                  <i class="icon-settings"></i>
                                </template>
                                <b-dropdown-item @click="selectedPhotoEventHandler(photo)" v-b-modal.confirmDeletePhotoModal v-b-modal.modal-center> Delete</b-dropdown-item>
                                <b-dropdown-item @click="downloadEventHandler(photo)"> Download</b-dropdown-item>
                              </b-dropdown>
                              </p>
                        </b-card>
                    </b-card-group> -->
                    <div ref="loading" class="centered" v-if="showLoading">
                          Loading... <b-img src="/static/img/spinner.gif" height="24" width="24"/> 
                    </div>
                  </div>
                  <br><br>
                  <b-row>
                    <b-col>
                      <b-button ref="uploadPhotos" size="sm" variant="secondary" v-b-modal.uploadModal>
                        <i class="fa fa-plus"></i> Upload Photos
                      </b-button>                      
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-container>
        </b-form>
        <!--// FORM-->

        <!-- FOOTER -->  
        <div slot="footer" class="float-right">
          <b-button :disabled="!landFormModified" variant="primary" @click="submitEventHandler"><i class="fa fa-save"></i> Save</b-button>&nbsp;
          <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> Close</b-button>          
        </div>
        <!--// FOOTER -->  

      </b-card>
    </div>

    <!-- MODAL Convoy -->
    <b-modal centered id="convoy" size="lg" ref="convoyModal" title="Convoy Information" class="modal-primary" ok-title="Add" @ok="submitModalEventHandler">
      <b-row>
        <b-col sm="12">
          <b-form>              
              <b-row>  
                <b-col sm="4">
                   <b-form-group class="required">
                      <label>Departure Location</label>
                      <b-form-input type="text" v-model="convoy.departure_location"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.departure_location') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group class="required">
                    <label>Departure Date</label>
                    <datepicker format="DD/MM/YYYY HH:mm:ss" v-model="convoy.departure_date" :local="local" :disabled-date="disabledDate" @input="departureDateChangeEventHandler"/><br>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.departure_date') }}</small>
                  </b-form-group>                  
                </b-col>
                <b-col sm="4">
                  <b-form-group class="required">
                    <label>Departure GPS</label>
                    <b-form-input type="text" v-model="convoy.departure_gps"></b-form-input>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.departure_gps') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group class="required">
                    <label>Arrival Location</label>
                    <b-form-input type="text" v-model="convoy.arrival_location"></b-form-input>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.arrival_location') }}</small>
                  </b-form-group>
                </b-col>  
                <b-col sm="4">
                  <b-form-group class="required">
                    <label>Arrival Date</label>
                    <datepicker format="DD/MM/YYYY HH:mm:ss" v-model="convoy.arrival_date" :local="local" :disabled-date="disabledArrivalDate" @input="arrivalDateChangeEventHandler"/><br>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.arrival_date') }}</small>
                  </b-form-group> 
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label>Arrival GPS</label>
                    <b-form-input type="text" v-model="convoy.arrival_gps"></b-form-input>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('convoy.arrival_gps') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>
          </b-form>
        </b-col>
      </b-row>      
    </b-modal>
    <!--// MODAL Convoy -->

    <!-- MODAL Participant -->
    <b-modal centered id="participant" size="md" ref="participantModal" title="Participant Information" class="modal-primary" ok-title="Add" @ok="submitModalEventHandler">
      <b-row>
        <b-col sm="12">
             <b-form>              
              <b-row>  
                <b-col>
                   <b-form-group class="required" :class="{error: validation.hasError('participant.name')}">
                      <label>Participant's Name</label>
                      <b-form-input type="text" v-model="participant.name"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('participant.name') }}</small>
                  </b-form-group>
                </b-col>                
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('participant.agency_id')}">
                      <label>Participant's Agency</label>
                      <!-- <b-form-select v-model="participant.agency_id" @change="agencyChangeEventHandler">
                        <template slot="first">
                          <option :value="null" disabled>-- select agency --</option>
                        </template>                        
                        <option v-for="o in agencyList" :value="o.id" :title="o.description">
                           {{ o.name }}
                        </option> 
                      </b-form-select> -->  

                      <b-form-select v-model="participant.agency_id" 
                            type="text" 
                            placeholder="Participant's Agency" 
                            text-field="name" 
                            value-field="id"
                            :options="agencyList"
                            @change="agencyChangeEventHandler">
                      </b-form-select>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('participant.agency_id') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group v-if="isOtherAgency" class="required" :class="{error: validation.hasError('participant.agency_id')}">
                      <label>Others</label>
                      <b-form-input type="text" ref="agencyOthers" v-model="participant.agency_others" placeholder="Enter agency name"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('participant.agency_others') }}</small>
                  </b-form-group>
                </b-col> 
              </b-row>  
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('participant.mobile_no')}">
                    <label>Convoy Leader Mobile No.</label>
                    <b-form-input type="text" v-model="participant.mobile_no"></b-form-input>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('participant.mobile_no') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>            
          </b-form>
        </b-col>
      </b-row>
    </b-modal>    
    <!--// MODAL Participant -->

    <!-- MODAL Vehicle -->
    <b-modal centered id="vehicle" size="md" ref="vehicleModal" title="Vehicle Information" class="modal-primary" ok-title="Add" @ok="submitModalEventHandler">
      <b-row>
        <b-col sm="12">
             <b-form>
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('vehicle.model')}">
                      <label>Make & Model</label>
                      <b-form-input type="text" v-model="vehicle.model" placeholder="Enter vehicle model"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('vehicle.model') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('vehicle.color')}">
                      <label>Color</label>
                      <b-form-input type="text" v-model="vehicle.color" placeholder="Enter vehicle model"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('vehicle.color') }}</small>
                  </b-form-group>
                </b-col> 
              </b-row>  
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('vehicle.plate')}">
                      <label>Plate</label>
                      <b-form-input type="text" v-model="vehicle.plate" placeholder="Enter vehicle plate no."></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('vehicle.plate') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('vehicle.roof_marking')}">
                      <label>Roof Marking</label>
                      <b-form-input type="text" v-model="vehicle.roof_marking" placeholder="Enter vehicle roof marking"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('vehicle.roof_marking') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group id="vehicleRoofLabel" label="Armored" description="">
                    <b-form-radio-group v-model="vehicle.armored" :options="form.options" :name="vehicles.armored" placeholder="Vehicles Roof">
                      <b-form-radio v-bind:value="true">Yes</b-form-radio>
                      <b-form-radio v-bind:value="false">No</b-form-radio>
                    </b-form-radio-group>              
                  </b-form-group>
                </b-col>
              </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>    
    <!--// MODAL Vehicle -->

     <!-- MODAL Truck -->
    <b-modal centered id="truck" size="md" ref="truckModal" title="Truck Information" class="modal-primary" ok-title="Add" @ok="submitModalEventHandler">
      <b-row>
        <b-col sm="12">
             <b-form>
              <b-row>
                <b-col>
                  <b-form-group class="required">
                      <label>Name of Driver</label>
                      <b-form-input type="text" v-model="truck.driver_name" placeholder="Enter truck driver's name"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.driver_name') }}</small>
                  </b-form-group>
                </b-col>
               </b-row>
               <b-row> 
                <b-col sm="6">
                  <b-form-group class="required">
                      <label>Model</label>
                      <b-form-input type="text" v-model="truck.model" placeholder="Enter truck's model"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.model') }}</small>
                  </b-form-group>
                </b-col> 
                <b-col sm="6">
                  <b-form-group class="required">
                      <label>Color</label>
                      <b-form-input type="text" v-model="truck.color" placeholder="Enter truck's color"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.color') }}</small>
                  </b-form-group>
                </b-col>                 
              </b-row>  
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required">
                      <label>Truck Plate No.</label>
                      <b-form-input type="text" v-model="truck.plate_no" placeholder="Enter truck's plate no."></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.plate_no') }}</small>
                  </b-form-group>
                </b-col> 
                <b-col sm="6">
                  <b-form-group class="required">
                      <label>Roof Marking</label>
                      <b-form-input type="text" v-model="truck.roof_marking" placeholder="Enter truck's roof marking"></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.roof_marking') }}</small>
                  </b-form-group>
                </b-col> 
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group class="required">
                      <label>Type of Load</label>
                      <b-form-input type="text" v-model="truck.load_type" placeholder="Enter type of load"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.load_type') }}</small>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group class="required" :class="{error: validation.hasError('truck.weight')}">
                      <label>Weight (MT)</label>
                      <b-form-input type="number" step="any" min="1" v-model="truck.weight" placeholder="Enter truck's weight"></b-form-input>                      
                      <small class="text-danger font-weight-bold">{{ validation.firstError('truck.weight') }}</small>
                  </b-form-group>
                </b-col>
              </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>    
    <!--// MODAL Truck -->

    <!--// MODAL Confirm Save -->   
    <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal" id="confirmSaveModal" @ok="confirmSaveEventHandler" @cancel="close" ok-title="Save" cancel-title="Cancel" centered>
        <p class="my-4">You have unsaved changes on this form.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>     
    </b-modal>  
    <!--// MODAL Confirm Save -->

     <!--// MODAL MoFA -->   
    <b-modal title="Success" class="modal-primary" ref="confirmMofaModal" id="confirmMofaModal" @ok="confirmEventHandler" @cancel="close" ok-title="Next" cancel-title="Cancel" centered>
      <b-row>
        <b-col sm="2" class="text-center"><i class="fa fa-check-circle fa-3x text-success"></i> </b-col>
        <b-col sm="10"><p>You've successfully completed notification form.  Click <b>Next</b> to continue filling out {{ (submittedId === 0 || submittedId === 2) ? 'MoFA' : 'CENTCOM'}} form.</p>     </b-col>
      </b-row>        
    </b-modal>  
    <!--// MODAL MoFA -->

    <!--// MODAL Upload Document -->   
     <b-modal centered ref="uploadModal" title="Upload Vehicle Photos" class="modal-primary" id="uploadModal" ok-title="Done" @ok="doneUploadEventHandler">
      <b-row>
        <b-col sm="12">
          <b-form>
             <b-row>
                <b-col>
                  <b-alert :show="showUploadAlert"
                           dismissible
                           variant="warning">
                      <strong>Upload completed!</strong> You successfully upload the file.
                  </b-alert>
                  <b-alert :show="showUploadError"
                           dismissible
                           variant="danger">
                      <strong>Upload Error!</strong> File size must not exceed 1MB in size.
                  </b-alert>
                  <b-form>
                    <file-upload
                          ref='fileUpload'
                          title='Please enter description of the file into the description field and click "Browse" to select file from your local computer.  When ready, click "Start Upload" to start uploading the file.'
                          accept=".png, .jpg, .jpeg"
                          @event-handler="fileUploadEventHandler($event)">            
                    </file-upload>
                  </b-form>
                </b-col>                
             </b-row>             
          </b-form>
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Upload Document -->

    <!--// MODAL Confirm Remove Photo -->   
     <b-modal title="Confirm" class="modal-primary" id="confirmDeletePhotoModal" @ok="deletePhotoEventHandler" ok-title="Yes" cancel-title="No" centered>
        <p class="my-4">Are you sure you want to remove this photo?</p>     
    </b-modal>  
    <!--// MODAL Confirm Remove Attachment -->  

  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import * as types from '@/store/types'

import CommonService from '@/api/CommonService'
import NotificationService from '@/api/NotificationService'
import LandMovementService from '@/api/LandMovementService'
import UploadService from '@/api/UploadService'
import landMixin from '@/mixins/validators/LandMovement-validators'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'

export default {  
  components: {
    FileUpload
  },
  mixins: [
    landMixin
  ],
  data () {
    return {
      submitted: false,
      agencyOthers: null,
      isEdit: false,
      recID: -1,
      isOtherPurpose: false,
      isOtherAgency: false,
      convoys_checked_all: false,
      convoys_checked: [],
      participants_checked: [],
      participants_checked_all: false,
      vehicles_checked_all: false,
      vehicles_checked: [],
      trucks_checked_all: false,
      trucks_checked: [],
      // Deconfliction Form
      waypoint_fields: [
        {key: 'location', label: 'Location'},
        {key: 'gps', label: 'GPS'}
      ],
      convoys_list: [],
      convoys_size: 0,
      vehicles_size: 0,
      trucks_size: 0,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      showUploadAlert: false,
      showUploadError: false,
      isUploadReady: false,
      selectedPhoto: null,
      props: ['id'],      
      modified: {  
        notification: false,
        waypoints:  this.$store.state.map_modified,
        convoys: false,
        participants: false,
        trucks:  false,
        vehicles: false,
        photos: false
      },
      getRowCount (items) {
        return items.length
      },
      // Form Dialogs - Land Movement
      form: {},      
      convoy: { checked: false, departure_location:'', departure_date:'', departure_gps:'', arrival_location: '', arrival_date: '', arrival_gps:'', total_distance:'' ,total_duration:'' },  
      participant: { checked: false, name:'', agency_id:'', mobile_no:'', agency_others: ''},
      vehicle: { checked: false, model:'', color:'', plate:'', roof_marking:'', armored: false },
      truck: { checked: false, driver_name:'', plate_no:'', load_type:'', weight:'' },
      photos: [],
      showLoading: true,
      local: constants.DATE_LOCALE_EN
    }
  },  
  
  computed: {
    purposeOthers: {
        get() {
          return this.$store.state.purposeOthers
        },
        set(value) {
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, value)
        }
    },
    
    // photos: types.GET_PHOTOS,
    ...mapGetters({
      notificationId: types.GET_NOTIFICATION_ID,
      purposeId: types.GET_PURPOSE_ID,
      staticMap: types.GET_MAP,
      waypoints: types.GET_WAYPOINTS,
      convoys: types.GET_CONVOYS,          
      participants: types.GET_PARTICIPANTS,
      vehicles: types.GET_VEHICLES,
      trucks: types.GET_TRUCKS,       
      purposeList: types.GET_PURPOSES,
      agencyList: types.GET_AGENCIES,
      requestTypeList: types.GET_REQUEST_TYPES,
      landFormModified: types.GET_MODIFIED,
      mofaView: types.GET_VIEW_MOFA,
      startDate: types.GET_START_DATE,
      isOrgAnonymous: types.GET_ORG_ANONYMOUS,
      submittedId: types.GET_SUBMITTED_ID,
    }),
    getAgencyName: function () {
      return (p) => {
        for(var obj of this.agencyList) {
          if (obj.id === p.agency_id) {
              if (obj.id == constants.AGENCY_OTHERS)
                  return obj.name +":"+ p.agency_others
              else   
                  return obj.name
          }
        }
      }
    }    
  },
  methods: {

    getAgencyDescription: function(e) {
      console.log("*****")
      console.log(e)
      return e.description
    },

    downloadEventHandler(item) {
        CommonService.download(item).then( (resp) => {          
          
      })
    },

    departureDateChangeEventHandler (e) {
      this.$store.commit(types.MUTATE_MODIFIED, true)         
    },

    arrivalDateChangeEventHandler(e) { 
        this.$store.commit(types.MUTATE_MODIFIED, true) 
    },

    selectedPhotoEventHandler(item) {        
        this.selectedPhoto = item
    },

    deletePhotoEventHandler() {
      let item = this.selectedPhoto;
      const payload = {
            id : item.id,
            notification_id: item.notification_id
        }

        UploadService.remove(payload).then( (response) => {
           //this.$store.commit(types.MUTATE_PHOTOS, response)     
           //
           if (response) {
               LandMovementService.getPhotos(item.notification_id).then( (resp) => {
                this.photos = resp
              })
           }       
        })        
    },

    
    resetValidation (e) {
      this.isEdit = false
      this.convoy = { departure_location:'', departure_date:'', departure_gps:'', arrival_location: '', arrival_date: '', arrival_gps:'', total_distance:'' ,total_duration:'' }
      this.participant = { name:'', agency_id:'', mobile_no:'', agency_others: ''}
      
      this.vehicle = { model:'', color:'', plate:'', roof_marking:'', armored: false }
      this.truck = { driver_name:'', plate_no:'', load_type:'', weight:'', model:'', color:'', roof_marking:'' }

      if (e.target.id === 'convoy') {
          let len = this.convoys.length-1
          this.convoy.departure_date = this.convoys[len].arrival_date
          const arrivalDate = this.$moment( new Date(this.convoy.departure_date) ).format( 'DD/MM/YYYY 18:00:00')
          this.convoy.arrival_date = this.$moment(arrivalDate, 'DD/MM/YYYY HH:mm:ss').toDate()          
      } 

      this.validation.reset()
    },
    submitEventHandler () {
            
      const fieldsNotification = ['purposeId']
      const $this = this  
      //const fieldsMain = ['purposeId','purposeOthers','staticMap.roadmap','convoys','participants','vehicles','photos']
      const fieldsMain = ['purposeId','purposeOthers','staticMap.roadmap','convoys','photos']
      this.$validate(fieldsMain)
          .then(function(success) {
            if (success) {
                $this.save()
            }
            else {
              toast.error( "Please complete all required fields", "Error")
            }
      })
    },
    confirmSaveEventHandler() {

      const fieldsNotification = ['purposeId']
      const $this = this  
      const fieldsMain = ['purposeId','purposeOthers','staticMap.roadmap','convoys','vehicles','photos']
      this.$validate(fieldsMain)
          .then(function(success) {
            if (success) {
                $this.save()
                setTimeout(function () {
                    $this.close()
                }.bind(this), 300)
            }
            else {
              toast.error( "Please complete all required fields", "Error")
            }
      })
    },

    submitModalEventHandler(e) {
      e.preventDefault()
      const fieldsConvoy = ['convoy.departure_location','convoy.departure_date','convoy.departure_gps',
                            'convoy.arrival_location','convoy.arrival_date','convoy.arrival_gps']
      let fieldsParticipant = ['participant.name','participant.agency_id','participant.mobile_no','participant.agency_others']
      const fieldsVehicle = ['vehicle.model','vehicle.color','vehicle.plate','vehicle.roof_marking']
      const fieldsTruck = ['truck.driver_name','truck.plate_no','truck.load_type','truck.weight','truck.model','truck.color','truck.roof_marking']
      const id = e.target.id
      const $this = this

      // remove required validation if isOrgAnonymous is true
      if (this.isOrgAnonymous) {
          fieldsParticipant = [];
      }

      if (id === "convoy") {
          this.$validate(fieldsConvoy)
            .then(function(success) {
              if (success) {
                  $this.commitRecord(id)
                  $this.$refs.convoyModal.hide()
              }
            })
      } 
      else if (id === "participant") {
        this.$validate(fieldsParticipant)
            .then(function(success) {
              if (success) {
                  $this.commitRecord(id)
                  $this.$refs.participantModal.hide()
              }
            })
      }
      else if (id === "vehicle") {
        this.$validate(fieldsVehicle)
            .then(function(success) {
              if (success) {
                  $this.commitRecord(id)
                  $this.$refs.vehicleModal.hide()
              }
            })
      }
      else if (id === "truck") {
        this.$validate(fieldsTruck)
            .then(function(success) {
              if (success) {
                  $this.commitRecord(id)
                  $this.$refs.truckModal.hide()
              }
            })
      }      
    },  
    doneUploadEventHandler() {      
      this.$refs.uploadModal.hide()
    },  
    select (type, e) {
      let $this = this
      let idx = parseInt(e.target.value)      
      if (type === 'convoys') {
          if (e.target.checked) {              
              $this.convoys_checked.push(idx) 
          }
          else {
            $this.convoys_checked = $this.convoys_checked.filter(function(item) { 
                return item !== idx
            })
          }

          console.log($this.convoys_checked)
      }
      else if (type === 'participants') {
          if (e.target.checked) {
              this.participants_checked.push(idx)
  			  }
          else {
              $this.participants_checked = $this.participants_checked.filter(function(item) { 
                  return item !== idx
              })
            // this.$_.remove(this.participants_checked, function(obj) {
            //   return obj === e.target.value
            // })
          }
      }
      else if (type === 'vehicles') { 
     	  if (e.target.checked) {
				    this.vehicles_checked.push(idx)
			  }
        else {
              $this.vehicles_checked = $this.vehicles_checked.filter(function(item) { 
                  return item !== idx
              })
            // this.$_.remove(this.vehicles_checked, function(obj) {
            //   return obj === e.target.value
            // })
        }
      }
      else if (type === 'trucks') { 
			  if (e.target.checked) {
            this.trucks_checked.push(idx)
			  }
        else {
             $this.trucks_checked = $this.trucks_checked.filter(function(item) { 
                  return item !== idx
              })
            // this.$_.remove(this.trucks_checked, function(obj) {
            //   return obj === e.target.value
            // })
        }
      }
    },
    deleteAllModalItems (type) {
      let $this = this
      let temp = []
      this.$store.commit(types.MUTATE_MODIFIED, true)

      if (type === 'convoys') {
          $this.modified.convoys = true
          // $this.convoys_checked.forEach(function(value) {              
           let obj= $this.$store.state.land_movement.convoys
              for (var i=0; i < $this.$store.state.land_movement.convoys.length; i++) {
                   if (!obj[i].checked) {
                       temp.push( $this.$store.state.land_movement.convoys[i] )
                       obj[i].checked = false
                       //$this.$refs['convoy_'+i].checked = false
                       //$this.$store.state.land_movement.convoys[i].checked = false
                       //console.log($this.$refs['convoy_'+i])
                   }
              }
          // })
          
          $this.convoys_checked = []
          $this.$store.commit(types.MUTATE_CONVOYS, temp)
      }
      else if (type === 'participants') {
           $this.modified.participants = true
           //$this.participants_checked.forEach(function(value) {              
           let obj= $this.$store.state.land_movement.participants
              for (var i=0; i < obj.length; i++) {
                   if (!obj[i].checked) {
                       temp.push( $this.$store.state.land_movement.participants[i] )
                       obj[i].checked = false
                       //$this.$refs['convoy_'+i].checked = false
                       //$this.$store.state.land_movement.participants[i].checked = false
                       //console.log($this.$refs['convoy_'+i])
                   }
              }
          // })
          
          $this.participants_checked = []
          $this.$store.commit(types.MUTATE_PARTICIPANTS, temp)
        // for (var i = this.participants_checked.length -1; i >= 0; i--) {
        //   this.$store.state.land_movement.participants.splice(this.participants_checked[i],1)
        //   this.$store.commit(types.MUTATE_PARTICIPANTS, this.$store.state.land_movement.participants) 
        // }
      }
      else if (type === 'vehicles') {
          $this.modified.vehicles = true
          //$this.vehicles_checked.forEach(function(value) {  
           let obj= $this.$store.state.land_movement.vehicles            
              for (var i=0; i < $this.$store.state.land_movement.vehicles.length; i++) {
                   if (!obj[i].checked) {
                       temp.push( $this.$store.state.land_movement.vehicles[i] )
                       obj[i].checked = false
                       //$this.$refs['convoy_'+i].checked = false
                       // $this.$store.state.land_movement.vehicles[i].checked = false
                       //console.log($this.$refs['convoy_'+i])
                   }
              }
          //})
          
          $this.vehicles_checked = []
          $this.$store.commit(types.MUTATE_VEHICLES, temp)
        // for (var i = this.vehicles_checked.length -1; i >= 0; i--) {
        //   this.$store.state.land_movement.vehicles.splice(this.vehicles_checked[i],1)
        //   this.$store.commit(types.MUTATE_VEHICLES, this.$store.state.land_movement.vehicles) 
        // }
      }
      else if (type === 'trucks') {
         $this.modified.trucks = true
         // $this.trucks_checked.forEach(function(value) {    
         let obj= $this.$store.state.land_movement.trucks                      
              for (var i=0; i < $this.$store.state.land_movement.trucks.length; i++) {
                   if (!obj[i].checked) {
                       temp.push( $this.$store.state.land_movement.trucks[i] )
                       obj[i].checked = false
                       //$this.$refs['convoy_'+i].checked = false
                       // $this.$store.state.land_movement.trucks[i].checked = false
                       //console.log($this.$refs['convoy_'+i])
                   }
              }
          // })
          
          $this.trucks_checked = []
          $this.$store.commit(types.MUTATE_TRUCKS, temp)
        // for (var i = this.trucks_checked.length -1; i >= 0; i--) {
        //   this.$store.state.land_movement.trucks.splice(this.trucks_checked[i],1)
        //   this.$store.commit(types.MUTATE_TRUCKS, this.$store.state.land_movement.trucks) 
        // }
      }
    },
    deleteHandler (type, index) {
      if (type === 'participant') {
        this.$delete(this.$store.state.land_movement.participants, index)
        this.$store.commit(types.MUTATE_PARTICIPANTS, this.$store.state.land_movement.participants)
      }
      else if (type === 'vehicle') {
        this.$delete(this.$store.state.land_movement.vehicles, index)
        this.$store.commit(types.MUTATE_VEHICLES, this.$store.state.land_movement.vehicles)
      }
      else if (type === 'truck') {
        this.$delete(this.$store.state.land_movement.trucks, index)
        this.$store.commit(types.MUTATE_TRUCKS, this.$store.state.land_movement.trucks)
      }
      else if (type === 'convoy') {
        this.$delete(this.$store.state.land_movement.convoys, index) 
        this.$store.commit(types.MUTATE_CONVOYS, this.$store.state.land_movement.convoys)
      }
    },

    disabledArrivalDate(time) {
        let temp = this.$moment(this.convoy.departure_date, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DDTHH:mm:ss")
        let _fromDate = this.$moment(temp)
        return time < this.$moment(_fromDate).toDate()
    },

    disabledDate (time) {
      let temp = this.$moment(this.$store.state.start_date, 'YYYY-MM-DDTHH:mm:ssZ').format("YYYY-MM-DDTHH:mm:ss")
      let dStartDate = this.$moment(temp)
      return time < dStartDate.toDate()
    },

    async save() {
      let $this = this
      let currentDate = $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ')
      let payload = {
        id: this.$store.state.notificationId,
        agency_id: this.$store.state.agencyId,
        requested_date: currentDate,
        request_type_id: constants.FORM_LAND_MOVEMENT,
        requested_by: this.$store.state.userId,
        purpose_id:  this.purposeId,       
        purpose_others:  this.purposeOthers,
        route_map_terrain: this.$store.state.map.roadmap,
        route_map_satellite: this.$store.state.map.satellite,
        ehoc_ref: this.$store.state.ehocRef,        
        notes: this.$store.state.notes,
        last_updated_by: this.$store.state.userId,
        last_update: currentDate,
        status_id: constants.STATUS_INUSE
      }

     if ($this.$store.state.permission === constants.ADMIN) { 
         payload.status_id = $this.$store.state.statusId
     }
      if (payload.id == 0) {

          // SAVE Notification          
          // await NotificationService.addNotification(payload).then( (response) => {
          //   const notificationId = response.id; 
          //   // store notification into state
          //   this.$store.commit(types.MUTATE_NOTIFICATION_ID, notificationId)
          //   this.$store.commit(types.MUTATE_MODIFIED, false)
          //   this.saveWaypoints(notificationId)
          //   this.saveConvoys(notificationId)
          //   this.saveParticipant(notificationId)
          //   this.saveVehicles(notificationId)
          //   this.saveTrucks(notificationId)

          //   toast.success( "Saved successfully")

          //   setTimeout(function () {
          //        console.log("Ready to show MoFA")
          //        $this.$refs.confirmMofaModal.show()
          //     }.bind(this), 300)
          // })          
      }
      else {
          // UPDATE Notification
          const notificationId = this.$store.state.notificationId
          payload.id = notificationId
          
          let ctr = 0;
          if (this.landFormModified) {
            await NotificationService.updateNotification(payload).then( (response) => {
              ctr++
            })
          }  
          if (this.landFormModified) {
              this.saveWaypoints(notificationId)
              ctr++
          }
          if (this.landFormModified) {
              this.saveConvoys(notificationId)
              ctr++
          }
          if (this.modified.participants) {
              this.saveParticipant(notificationId)
              ctr++
          }
          if (this.modified.vehicles) {
              this.saveVehicles(notificationId)
              ctr++
          }
          if (this.modified.trucks) {
              this.saveTrucks(notificationId)
              ctr++
          } 
          // show save message
          if (ctr > 0) {
            this.$store.commit(types.MUTATE_MODIFIED, false)            
            this.modified.participants = false
            this.modified.vehicles = false
            this.modified.trucks = false

            // update notification status
            //this.changeNotifcationStatus(constants.STATUS_INUSE)
          
            toast.success( "Saved successfully")

            if (this.$store.state.new_notification) {
                setTimeout(function () {
                   $this.$refs.confirmMofaModal.show()
                }.bind(this), 300)
            } 
          }
      }
    },

   changeNotifcationStatus(statusId) {
    let status = this.$_.find(this.$store.state.statusList, {id: statusId});
    let notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm') +'\n'+ status.name

    const payload = {
          id : this.notificationId,
          status_id : status.id,
          notes : notes,
          ehoc_ref: this.$store.state.ehocRef,
          last_updated_by: this.$store.state.userId
      }
      this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)
    },

    updateModal (index, type) {
      this.isEdit = true
      this.recID = index
      if (type === 'convoy') {
         this.convoy = this.$store.state.land_movement.convoys[index]
      }
      else if (type === 'participant') {
        this.participant = this.$store.state.land_movement.participants[index]
      }
      else if (type === 'vehicle') {
        this.vehicle = this.$store.state.land_movement.vehicles[index]
      }
      else if (type === 'truck') {
        this.truck = this.$store.state.land_movement.trucks[index]
      }
    },
    closeModals(e) {
      //this.validation.reset() 

      this.truck = { driver_name:'', plate_no:'', load_type:'', weight:'' }
      this.vehicle =  { model:'', color:'', plate:'', roof_marking:'', armored: 0}
      this.participant = {name: '', agency_id:'', mobile_no: ''}
      this.convoy = { departure_location:'', departure_date:'', departure_gps:'', arrival_location: '', arrival_date: '', arrival_gps:'', total_distance:'' ,total_duration:'' }
      if (e === 'convoy') this.$refs.convoyModal.hide()
      if (e === 'participant') this.$refs.partDetails.hide()
      if (e === 'vehicle') this.$refs.vehiclesDetails.hide()
      if (e === 'truck') this.$refs.trucksDetails.hide()
      if (e === 'upload') this.$refs.uploadModal.hide()
      this.isEdit = false      
    },

    async fileUploadEventHandler(event) {
        const notificationId = this.$store.state.notificationId
        const requestTypeId = this.$store.state.requestTypeId
        const category = "VEHICLE_PHOTO"
        const $this = this
        this.showUploadError = false
        
        let file = event.file
        if (!file) return

        console.log("File size: "+ file.size)

        // validate if file exceeds 1mb
        if (file.size >= constants.FILE_MAXIMUM_SIZE) {
            this.showUploadError = true            
            return
        }
        
        let formData = new FormData()
        formData.append('file', file, file.name)

        this.showUploadAlert = true

        
        await UploadService.upload(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
            if (resp.length > 0) {
                $this.isUploadReady = true 
                setTimeout(function () {
                    $this.showUploadAlert = false
                    $this.$refs.fileUpload.reset()
                }.bind($this), 1000)

                // get photos 
                //$this.$store.dispatch(types.ACTION_FIND_PHOTOS, notificationId)
                
                LandMovementService.getPhotos(notificationId).then( (resp) => {
                  //this.$store.commit(types.MUTATE_PHOTOS, resp)
                  this.photos = resp
                })
            }          
        })
    },
    createRoute() {
      this.$router.replace({path:'/map', query: {param:'land-movement'} })      
    },
    async saveConvoys(id) {
      let payload = this.$store.state.land_movement.convoys

      console.log("**************")
      console.log(payload)
      console.log("**************")
      for (var obj of payload) {
          obj.notification_id = id
      }
      await LandMovementService.addConvoys(payload).then( (response) => {
      })
    },
    saveWaypoints(id) {
      // set payload to waypoints
      let payload = this.$store.state.waypoints
      // iterate payload to add notification id
      for (var obj of payload) {
          obj.notification_id = id
      }
      // save waypoints 
      LandMovementService.addWaypoints(payload)      
    },
    async saveParticipant (id) {
      let payload = this.$store.state.land_movement.participants
      for (var obj of payload) {
          obj.notification_id = id
      }
      await LandMovementService.addParticipants(payload).then( (response) => {
      })
    },
    async loadPhotos() {
      let $this = this
         await LandMovementService.getPhotos(this.$store.state.notificationId).then( (resp) => {        
            if (resp) {
              this.photos = resp
              $this.showLoading = false
            }
        })
    },

    async saveVehicles (id) {
      let payload = this.$store.state.land_movement.vehicles
      for (var obj of payload) {
        obj.notification_id = id
      }
      await LandMovementService.addVehicles(payload).then( (response) => {
      })
    },
    saveTrucks (id) {
      let payload = this.$store.state.land_movement.trucks
      for (var obj of payload) {
        obj.notification_id = id
      }
      const response = LandMovementService.addTrucks(payload)
    },
    getFormVals (e) {
      e.preventDefault()
      this.$store.commit(types.MUTATE_PURPOSE_OTHERS, this._data.purposeOtherss)
        // NOTE:  Please check the validation
        this.save()
    },
    agencyChangeEventHandler (e) {
      this.isOtherAgency = (e === constants.AGENCY_OTHERS)
      if (this.isOtherAgency) {
          setTimeout(function () {
                    this.$refs.agencyOther.$el.focus()
                  }.bind(this), 300) 
      }
    },
    purposeChangeEventHandler (e) {
      this.isOtherPurpose = (e === constants.PURPOSE_OTHERS)
       
      if (this.isOtherPurpose) {
          setTimeout(function () {
                    this.$refs.purposeOthers.$el.focus()
                  }.bind(this), 300) 
      } else {
        this.$store.commit(types.MUTATE_PURPOSE_OTHERS, "")
      }
      this.$store.commit(types.MUTATE_PURPOSE_ID, e)
      this.$store.commit(types.MUTATE_MODIFIED, true)
      this.modified.notification = true
    }, 
    commitRecord (type) {
      this.$store.commit(types.MUTATE_MODIFIED, true)
      if (type === 'convoy') {
        let cTemp = []
        //this.modified.convoys = true
        cTemp =  this.$store.state.land_movement.convoys
           if (!this.isEdit) {
            cTemp.push(this._data.convoy)
            this.$store.commit(types.MUTATE_CONVOYS, cTemp)
            this.convoy = { departure_location:'', departure_date:'', departure_gps:'', arrival_location: '', arrival_date: '', arrival_gps:'', total_distance:'' ,total_duration:'' }
          }
          else {
            // update convoy state
            this.$store.state.land_movement.convoys[this.recID] = this._data.convoy
            this.$store.commit(types.MUTATE_CONVOYS, cTemp)            
          }
        //}
      }
      else if (type === 'participant') {
        let pTemp = [] 
        this.modified.participants = true
        pTemp = this.$store.state.land_movement.participants
        
          if (!this.isEdit) {
            pTemp.push(this._data.participant)
            this.$store.commit(types.MUTATE_PARTICIPANTS,pTemp)
            this.participant = {name: '', agency_id:'', mobile_no: '', agency_others: ''} 
          }
          else {
            this.$store.state.land_movement.participants[this.recID] = this._data.participant
            this.$store.commit(types.MUTATE_PARTICIPANTS, pTemp)            
          }        
      }
      else if (type === 'vehicle') {
        let vTemp = []
        this.modified.vehicles = true
        vTemp = this.$store.state.land_movement.vehicles
        
          if (!this.isEdit) {
            vTemp.push(this._data.vehicle)
            this.$store.commit(types.MUTATE_VEHICLES, vTemp)
            this.vehicle =  { model:'', color:'', plate:'', roof_marking:'', armored: 0}
          }
          else {
            this.$store.state.land_movement.vehicles[this.recID] = this._data.vehicle
            this.$store.commit(types.MUTATE_VEHICLES,vTemp)            
          }
        //}
      }
      else if (type === 'truck') {
        let tTemp = []
        this.modified.trucks = true
        tTemp = this.$store.state.land_movement.trucks
          if (!this.isEdit) {
            tTemp.push(this._data.truck)
            this.$store.commit(types.MUTATE_TRUCKS,tTemp)
            this.truck = { driver_name:'', plate_no:'', load_type:'', weight:'' }
          }
          else {
            this.$store.state.land_movement.trucks[this.recID] = this._data.truck
            this.$store.commit(types.MUTATE_TRUCKS,tTemp)            
          }
      }
      else if (type === 'uploadPhotos') {
        let fTemp = []
      }      
    },
    closeEventHandler () {
      if (this.landFormModified) {
          this.$refs.confirmSaveModal.show()
      } 
      else {
          this.close()
      }
    },
    close() {
        this.$store.commit(types.MUTATE_RESET_STATE)
        this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        if (this.$store.state.permission === constants.ADMIN) {
            this.$router.replace('/dashboard')
        }    
        else {
            this.$router.replace('/user-dashboard')
        }        
    },    

    confirmEventHandler() {
      if (this.submittedId === 0 || this.submittedId === 2) {
          this.mofaEventHandler();
      } else {
          this.mofaCentcomEventHandler();
      }
    },

    mofaEventHandler() {

       const routeName = utils.findMofaNameById( this.$store.state.requestTypeId )
       const notificationId = this.$store.state.notificationId

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:notificationId})
            this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        }.bind(this), 600)
       
       
        // load MOFA form
        this.$router.replace('/forms/'+ routeName +"-mofa")       
    },
    mofaCentcomEventHandler() {

       const routeName = utils.findMofaNameById( this.$store.state.requestTypeId )
       const notificationId = this.$store.state.notificationId

       console.log('******* /forms/'+ routeName +"-mofa-centcom")

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA_CENTCOM, {type: routeName , id:notificationId})
            this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        }.bind(this), 600)
       
        // load MOFA form
        this.$router.replace('/forms/'+ routeName +"-mofa-centcom")
    },    
    changeEventHandler() {
      this.modified.notification = true
      this.$store.commit(types.MUTATE_MODIFIED, true)
    }
  },
  created() {
      this.$store.dispatch(types.ACTION_FIND_PURPOSES, constants.FORM_LAND_MOVEMENT)     
  },
  mounted() {

    this.$nextTick(function () {      
      // this.$store.commit(types.MUTATE_MODIFIED, false)      
      setTimeout(function () {
         if (this.$store.state.purposeId === constants.PURPOSE_OTHERS) {
            this.isOtherPurpose = true
         }
         this.validation.reset()

      }.bind(this), 600)

      setTimeout(function () {
          this.loadPhotos()
        //  LandMovementService.getPhotos(this.$store.state.notificationId).then( (resp) => {        
        //   this.photos = resp
        // })
      }.bind(this), 3000)      
      
    })
    
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,  
.fade-leave-to {
  opacity: 0;
}
h5 {
  color: #373767;
}
label::after {
  content: '*';
  margin-right: 4px;
  color: red;
}
.emptyImage {
    min-height: 200px;
    width: 99%;
    display: inline-block;
    border: #c8ced3 solid 1px;
    background: #f5f5f5;
    text-align: center;
    padding: 20px;    
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  
}

.form-group.required label::after {
   margin-right: 2px;
   content:"*";
   color:red;
}
span.required {
  color:red; 
}

@media (min-width:576px) {
    .card-columns {
      column-count: 2;
    }
}
  @media (min-width:768px) {
    .card-columns {
      column-count: 3;
    }
}
@media (min-width:992px) {
    .card-columns {
      column-count: 4;
    }
}
@media (min-width:1200px) {
    .card-columns {
      column-count: 5;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/forms/LandMovement.vue